import React, { useEffect } from 'react';

interface UseTableScrollDimensionsParams {
  primaryElement: HTMLDivElement | null;
  setClientWidth: React.Dispatch<React.SetStateAction<number>>;
  setScrollWidth: React.Dispatch<React.SetStateAction<number>>;
  remeasureKey?: string;
}

export const useTableScrollDimensions = ({
  primaryElement,
  setClientWidth,
  setScrollWidth,
  remeasureKey,
}: UseTableScrollDimensionsParams) => {
  useEffect(() => {
    if (!primaryElement) {
      return;
    }

    const updateDimensions = () => {
      setClientWidth(primaryElement.offsetWidth || 0);
      setScrollWidth(primaryElement.scrollWidth || 0);
    };

    const observer = new ResizeObserver(updateDimensions);
    observer.observe(primaryElement);

    const observeContent = () => {
      const contentElement = primaryElement.querySelector('table');
      if (contentElement) {
        observer.observe(contentElement);
      }
    };

    observeContent();
    updateDimensions();

    const frameId = requestAnimationFrame(() => {
      observeContent();
      updateDimensions();
    });

    return () => {
      cancelAnimationFrame(frameId);
      observer.disconnect();
    };
  }, [primaryElement, setClientWidth, setScrollWidth, remeasureKey]);
};
